<template>
  <div id="ubottom">
    <div class="clearfix"/>
    <hr>
    <div class="menu">{{ $t("cmsg.copyright") }}{{$gf.sysParam($gf.lang(), "copyright")}}
      <el-button type="text" @click="privacyVisible = true" class="btn_privacy" v-if="$gf.lang() === 'en'">Privacy Policy</el-button>
      <el-dialog
  title="Privacy Policy"
  :visible.sync="privacyVisible"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  width="80%">
  <privacyEnLib/>
</el-dialog>
      <br />{{$t('cmsg.browserSupport')}}</div>
  </div>
</template>

<script>
import privacyEnLib from "@/views/component/privacyEn.vue";
export default {
  name: "bottom",
  components: {
    privacyEnLib
  },
  data() {
    return {
      privacyVisible: false
      };
  },
  methods: {},
  mounted() {}
};
</script>
<style lang="scss">
#ubottom {
  padding-bottom: 25px;
  background-color: #ffffff;
  hr {
    color: #4b91d1;
    background-color: #4b91d1;
    height: 1px;
    margin: 0;
    border-width: 0px;
  }
  .menu {
    margin: 0 auto;
    text-align: left;
    margin: 15px;
  }
}
</style>
